import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkBannerMessage, markBannerMessageAsRead } from '../../redux/actions/Talent';


const BannerMessage = ({ token }) => {
  const dispatch = useDispatch();
  const {bannerMessage} = useSelector(({talent}) => talent)  

  const [bannerMessages, setBannerMessages] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);



  useEffect(() => {
    if (Array.isArray(bannerMessage)) {
      const filtered = bannerMessage.filter((msg) => {
        const local = localStorage.getItem(`banner_shown_${msg?.id}`);
        return local !== "true";
      });

      setBannerMessages(filtered);
    }
  }, [bannerMessage]);

  useEffect(() => {
    if (bannerMessages.length > 1) {
      const interval = setInterval(() => {
        setCurrentMessageIndex((prevIndex) =>
          (prevIndex + 1) % bannerMessages.length
        );
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [bannerMessages]);

  const handleClose = (id) => {
    dispatch(markBannerMessageAsRead(token, id));
    localStorage.setItem(`banner_shown_${id}`, "true");

    const filtered = bannerMessages.filter((msg) => msg?.id !== id);
    setBannerMessages(filtered);

    if (filtered.length > 0) {
      setCurrentMessageIndex((prevIndex) =>
        prevIndex >= filtered.length ? 0 : prevIndex
      );
    }
  };

  const currentMessage = bannerMessages[currentMessageIndex];

  if (!currentMessage || localStorage.getItem(`banner_shown_${currentMessage.id}`) === "true") {
    return null;
  }

  return (
    <div
      key={currentMessage.id}
      className="p-4 flex items-center justify-between w-full shadow-md z-50 transition-all duration-500"
      style={{
        backgroundColor: currentMessage.banner_color,
        color: currentMessage.text_color,
      }}
    >
      <div className="flex items-center ml-20 gap-3">
        <i className="fa fa-bell" aria-hidden="true"></i>
        <p>
          <strong>{currentMessage.title}</strong> - {currentMessage.message}
        </p>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <button
            className={`${currentMessage.text_color} font-bold`}
            onClick={() =>
              setCurrentMessageIndex((prevIndex) =>
                prevIndex === 0 ? bannerMessages.length - 1 : prevIndex - 1
              )
            }
          >
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
          <span className={`${currentMessage.text_color} font-medium text-sm`}>
            {currentMessageIndex + 1} / {bannerMessages.length}
          </span>
          <button
            className={`${currentMessage.text_color} font-bold`}
            onClick={() =>
              setCurrentMessageIndex((prevIndex) =>
                (prevIndex + 1) % bannerMessages.length
              )
            }
          >
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        <button
          onClick={() => handleClose(currentMessage.id)}
          className="text-white font-bold text-lg"
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default BannerMessage;
